// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var ApiConfiguration$ReactHooksTemplate = require("./apiConfiguration.res.js");

function initialState(api, apiType) {
  var defaultApi = ApiConfiguration$ReactHooksTemplate.empty(apiType);
  var formData = api !== undefined ? api : defaultApi;
  return {
          formData: formData,
          errors: /* [] */0
        };
}

function validateForm(state) {
  var errors = /* [] */0;
  if (state.formData.name.trim() === "") {
    errors = {
      hd: "Name is required",
      tl: errors
    };
  }
  if (state.formData.url.trim() === "") {
    errors = {
      hd: "URL is required",
      tl: errors
    };
  }
  try {
    JSON.parse(state.formData.headers);
  }
  catch (exn){
    errors = {
      hd: "Headers must be valid JSON",
      tl: errors
    };
  }
  try {
    JSON.parse(state.formData.credentials);
  }
  catch (exn$1){
    errors = {
      hd: "Credentials must be valid JSON",
      tl: errors
    };
  }
  try {
    JSON.parse(state.formData.staticParams);
  }
  catch (exn$2){
    errors = {
      hd: "Static Parameters must be valid JSON",
      tl: errors
    };
  }
  try {
    JSON.parse(state.formData.dynamicParams);
  }
  catch (exn$3){
    errors = {
      hd: "Dynamic Parameters must be valid JSON",
      tl: errors
    };
  }
  return errors;
}

function ApiConfigurationForm(props) {
  var apiType = props.apiType;
  var onCancel = props.onCancel;
  var onSubmit = props.onSubmit;
  var api = props.api;
  var match = React.useState(function (param) {
        return initialState(api, apiType);
      });
  var setState = match[1];
  var state = match[0];
  var handleInputChange = function (field, value) {
    Curry._1(setState, (function (prevState) {
            var tmp;
            switch (field) {
              case "credentials" :
                  tmp = ApiConfiguration$ReactHooksTemplate.setCredentials(prevState.formData, value);
                  break;
              case "dynamicParams" :
                  tmp = ApiConfiguration$ReactHooksTemplate.setDynamicParams(prevState.formData, value);
                  break;
              case "headers" :
                  tmp = ApiConfiguration$ReactHooksTemplate.setHeaders(prevState.formData, value);
                  break;
              case "isActive" :
                  tmp = ApiConfiguration$ReactHooksTemplate.setIsActive(prevState.formData, value.toLowerCase() === "true");
                  break;
              case "method" :
                  tmp = ApiConfiguration$ReactHooksTemplate.setMethod(prevState.formData, value);
                  break;
              case "name" :
                  tmp = ApiConfiguration$ReactHooksTemplate.setName(prevState.formData, value);
                  break;
              case "staticParams" :
                  tmp = ApiConfiguration$ReactHooksTemplate.setStaticParams(prevState.formData, value);
                  break;
              case "url" :
                  tmp = ApiConfiguration$ReactHooksTemplate.setUrl(prevState.formData, value);
                  break;
              default:
                tmp = prevState.formData;
            }
            return {
                    formData: tmp,
                    errors: prevState.errors
                  };
          }));
  };
  var handleSubmit = function ($$event) {
    $$event.preventDefault();
    var errors = validateForm(state);
    if (Belt_List.length(errors) === 0) {
      return Curry._1(onSubmit, state.formData);
    } else {
      return Curry._1(setState, (function (prevState) {
                    return {
                            formData: prevState.formData,
                            errors: errors
                          };
                  }));
    }
  };
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx("h3", {
                                        children: api !== undefined ? "Edit API" : "Create New API",
                                        className: "text-lg font-medium text-darkcharcoal"
                                      }),
                                  className: "px-8 py-6 border-b border-gray-200"
                                }),
                            JsxRuntime.jsxs("form", {
                                  children: [
                                    JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("div", {
                                                        children: JsxRuntime.jsx("svg", {
                                                              children: JsxRuntime.jsx("path", {
                                                                    clipRule: "evenodd",
                                                                    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
                                                                    fillRule: "evenodd"
                                                                  }),
                                                              className: "h-5 w-5 text-blue-400",
                                                              fill: "currentColor",
                                                              viewBox: "0 0 20 20"
                                                            }),
                                                        className: "flex-shrink-0"
                                                      }),
                                                  JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx("h3", {
                                                                children: "Parameter Configuration Guide",
                                                                className: "text-sm font-medium text-blue-800"
                                                              }),
                                                          JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  JsxRuntime.jsx("p", {
                                                                        children: "Static Parameters: Values that remain the same for all requests (e.g., sender_id, api_key)",
                                                                        className: "mb-2"
                                                                      }),
                                                                  JsxRuntime.jsx("p", {
                                                                        children: "Dynamic Parameters: Values that change with each request. Use placeholders like %{msisdn} for mobile number, %{text} for message",
                                                                        className: "mb-2"
                                                                      }),
                                                                  JsxRuntime.jsx("p", {
                                                                        children: "Example: {\"mobile\": \"%{msisdn}\", \"message\": \"%{text}\", \"sender_id\": \"COMPANY\"}"
                                                                      })
                                                                ],
                                                                className: "mt-2 text-sm text-blue-700"
                                                              })
                                                        ],
                                                        className: "ml-3"
                                                      })
                                                ],
                                                className: "flex"
                                              }),
                                          className: "bg-blue-50 border border-blue-200 rounded-md p-4 mb-6"
                                        }),
                                    Belt_List.length(state.errors) > 0 ? JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx("div", {
                                                          children: JsxRuntime.jsx("svg", {
                                                                children: JsxRuntime.jsx("path", {
                                                                      clipRule: "evenodd",
                                                                      d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                                                                      fillRule: "evenodd"
                                                                    }),
                                                                className: "h-20-px w-20-px text-firebrick",
                                                                fill: "currentColor",
                                                                viewBox: "0 0 20 20"
                                                              }),
                                                          className: "flex-shrink-0"
                                                        }),
                                                    JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsx("h3", {
                                                                  children: "Please correct the following errors:",
                                                                  className: "text-sm font-medium text-firebrick"
                                                                }),
                                                            JsxRuntime.jsx("div", {
                                                                  children: JsxRuntime.jsx("ul", {
                                                                        children: $$Array.of_list(Belt_List.map(state.errors, (function (error) {
                                                                                    return JsxRuntime.jsx("li", {
                                                                                                children: error
                                                                                              }, error);
                                                                                  }))),
                                                                        className: "list-disc pl-20-px space-y-4-px"
                                                                      }),
                                                                  className: "mt-8-px text-sm text-firebrick"
                                                                })
                                                          ],
                                                          className: "ml-12-px"
                                                        })
                                                  ],
                                                  className: "flex"
                                                }),
                                            className: "bg-failure border border-firebrick rounded-md p-20-px"
                                          }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx("label", {
                                                          children: "Name",
                                                          className: "block text-sm font-medium text-aurometalsaurus",
                                                          htmlFor: "name"
                                                        }),
                                                    JsxRuntime.jsx("input", {
                                                          className: "mt-8-px block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-600 focus:border-blue-600 sm:text-sm h-40-px px-12-px",
                                                          id: "name",
                                                          placeholder: "Enter API name",
                                                          type: "text",
                                                          value: state.formData.name,
                                                          onChange: (function (e) {
                                                              handleInputChange("name", e.target.value);
                                                            })
                                                        })
                                                  ]
                                                }),
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx("label", {
                                                          children: "HTTP Method",
                                                          className: "block text-sm font-medium text-aurometalsaurus",
                                                          htmlFor: "method"
                                                        }),
                                                    JsxRuntime.jsx("select", {
                                                          children: $$Array.of_list(Belt_List.map(ApiConfiguration$ReactHooksTemplate.availableMethods, (function (method) {
                                                                      return JsxRuntime.jsx("option", {
                                                                                  children: method,
                                                                                  value: method
                                                                                }, method);
                                                                    }))),
                                                          className: "mt-8-px block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-600 focus:border-blue-600 sm:text-sm h-40-px px-12-px",
                                                          id: "method",
                                                          value: state.formData.method,
                                                          onChange: (function (e) {
                                                              handleInputChange("method", e.target.value);
                                                            })
                                                        })
                                                  ]
                                                })
                                          ],
                                          className: "grid grid-cols-1 gap-6 sm:grid-cols-2"
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("label", {
                                                  children: "API URL",
                                                  className: "block text-sm font-medium text-aurometalsaurus",
                                                  htmlFor: "url"
                                                }),
                                            JsxRuntime.jsx("input", {
                                                  className: "mt-8-px block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-600 focus:border-blue-600 sm:text-sm h-40-px px-12-px",
                                                  id: "url",
                                                  placeholder: "https://api.example.com/sms",
                                                  type: "url",
                                                  value: state.formData.url,
                                                  onChange: (function (e) {
                                                      handleInputChange("url", e.target.value);
                                                    })
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("label", {
                                                  children: "Static Parameters (JSON)",
                                                  className: "block text-sm font-medium text-aurometalsaurus",
                                                  htmlFor: "staticParams"
                                                }),
                                            JsxRuntime.jsx("textarea", {
                                                  className: "mt-8-px block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-600 focus:border-blue-600 sm:text-sm font-mono h-120-px px-12-px py-8-px",
                                                  id: "staticParams",
                                                  placeholder: "{\"sender_id\": \"COMPANY\", \"api_key\": \"your_api_key\"}",
                                                  rows: 4,
                                                  value: state.formData.staticParams,
                                                  onChange: (function (e) {
                                                      handleInputChange("staticParams", e.target.value);
                                                    })
                                                }),
                                            JsxRuntime.jsx("p", {
                                                  children: "Static parameters that remain the same for all requests (e.g., sender_id, api_key)",
                                                  className: "mt-8-px text-sm text-aurometalsaurus"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("label", {
                                                  children: "Dynamic Parameters (JSON)",
                                                  className: "block text-sm font-medium text-aurometalsaurus",
                                                  htmlFor: "dynamicParams"
                                                }),
                                            JsxRuntime.jsx("textarea", {
                                                  className: "mt-8-px block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-600 focus:border-blue-600 sm:text-sm font-mono h-120-px px-12-px py-8-px",
                                                  id: "dynamicParams",
                                                  placeholder: "{\"mobile\": \"%{msisdn}\", \"message\": \"%{text}\", \"to\": \"%{recipient}\"}",
                                                  rows: 4,
                                                  value: state.formData.dynamicParams,
                                                  onChange: (function (e) {
                                                      handleInputChange("dynamicParams", e.target.value);
                                                    })
                                                }),
                                            JsxRuntime.jsx("p", {
                                                  children: "Dynamic parameters that change with each request (e.g., mobile number, message text)",
                                                  className: "mt-8-px text-sm text-aurometalsaurus"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("label", {
                                                  children: "Headers (JSON)",
                                                  className: "block text-sm font-medium text-aurometalsaurus",
                                                  htmlFor: "headers"
                                                }),
                                            JsxRuntime.jsx("textarea", {
                                                  className: "mt-8-px block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-600 focus:border-blue-600 sm:text-sm font-mono h-120-px px-12-px py-8-px",
                                                  id: "headers",
                                                  placeholder: "{\"Content-Type\": \"application/json\", \"Authorization\": \"Bearer token\"}",
                                                  rows: 4,
                                                  value: state.formData.headers,
                                                  onChange: (function (e) {
                                                      handleInputChange("headers", e.target.value);
                                                    })
                                                }),
                                            JsxRuntime.jsx("p", {
                                                  children: "Enter headers as a valid JSON object",
                                                  className: "mt-8-px text-sm text-aurometalsaurus"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("label", {
                                                  children: "Credentials (JSON)",
                                                  className: "block text-sm font-medium text-aurometalsaurus",
                                                  htmlFor: "credentials"
                                                }),
                                            JsxRuntime.jsx("textarea", {
                                                  className: "mt-8-px block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-600 focus:border-blue-600 sm:text-sm font-mono h-120-px px-12-px py-8-px",
                                                  id: "credentials",
                                                  placeholder: "{\"username\": \"user\", \"password\": \"pass\", \"api_key\": \"key\"}",
                                                  rows: 4,
                                                  value: state.formData.credentials,
                                                  onChange: (function (e) {
                                                      handleInputChange("credentials", e.target.value);
                                                    })
                                                }),
                                            JsxRuntime.jsx("p", {
                                                  children: "Enter credentials as a valid JSON object",
                                                  className: "mt-8-px text-sm text-aurometalsaurus"
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("label", {
                                                  children: "Status",
                                                  className: "block text-sm font-medium text-aurometalsaurus",
                                                  htmlFor: "isActive"
                                                }),
                                            JsxRuntime.jsxs("select", {
                                                  children: [
                                                    JsxRuntime.jsx("option", {
                                                          children: "Active",
                                                          value: "true"
                                                        }),
                                                    JsxRuntime.jsx("option", {
                                                          children: "Inactive",
                                                          value: "false"
                                                        })
                                                  ],
                                                  className: "mt-8-px block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-600 focus:border-blue-600 sm:text-sm h-40-px px-12-px",
                                                  id: "isActive",
                                                  value: state.formData.isActive ? "true" : "false",
                                                  onChange: (function (e) {
                                                      handleInputChange("isActive", e.target.value);
                                                    })
                                                })
                                          ]
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("button", {
                                                  children: "Cancel",
                                                  className: "bg-white py-6-px px-20-px border border-gray-300 rounded-md shadow-sm text-sm font-medium text-aurometalsaurus hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600",
                                                  type: "button",
                                                  onClick: (function (param) {
                                                      Curry._1(onCancel, undefined);
                                                    })
                                                }),
                                            JsxRuntime.jsx("button", {
                                                  children: api !== undefined ? "Update API" : "Create API",
                                                  className: "bg-blue-600 py-6-px px-20-px border border-transparent rounded-md shadow-sm text-sm font-medium text-white hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600",
                                                  type: "submit"
                                                })
                                          ],
                                          className: "flex justify-end space-x-3 pt-6 border-t border-gray-200"
                                        })
                                  ],
                                  className: "p-8 space-y-6",
                                  onSubmit: handleSubmit
                                })
                          ],
                          className: "bg-white shadow rounded-lg"
                        }),
                    className: "max-w-4xl mx-auto"
                  }),
              className: "p-8"
            });
}

var make = ApiConfigurationForm;

exports.initialState = initialState;
exports.validateForm = validateForm;
exports.make = make;
/* react Not a pure module */
